export function formatTitle(title, subtitle) {
    if (subtitle) {
        return `${title}: ${subtitle}`
    }

    return title
}
